import React from 'react';

interface CheckInButtonProps {
  canCheckIn: boolean;
  hasCheckedInToday: boolean;
  onCheckIn: () => void;
  loading?: boolean;
}

const CheckInButton: React.FC<CheckInButtonProps> = ({
  canCheckIn,
  hasCheckedInToday,
  onCheckIn,
  loading = false
}) => {
  const getButtonText = () => {
    if (hasCheckedInToday) {
      return 'Bugün Zaten Giriş Yapıldı';
    }
    return 'Giriş Yap';
  };

  const getButtonColor = () => {
    if (hasCheckedInToday) {
      return 'bg-green-600';
    }
    return 'bg-green-600 hover:bg-green-700';
  };

  const getStatusText = () => {
    if (hasCheckedInToday) {
      return '✅ Bugün giriş yapıldı';
    }
    return 'Bugün giriş yapılmadı';
  };

  const isDisabled = !canCheckIn || loading || hasCheckedInToday;

  return (
    <div className="text-center">
      <div className="mb-4">
        <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
          hasCheckedInToday 
            ? 'bg-green-100 text-green-800' 
            : 'bg-gray-100 text-gray-800'
        }`}>
          <div className={`w-2 h-2 rounded-full mr-2 ${
            hasCheckedInToday ? 'bg-green-400' : 'bg-gray-400'
          }`}></div>
          {getStatusText()}
        </div>
      </div>

      <button
        onClick={onCheckIn}
        disabled={isDisabled}
        className={`w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed ${
          isDisabled ? 'bg-gray-400 cursor-not-allowed' : getButtonColor()
        }`}
      >
        {loading ? 'İşleniyor...' : getButtonText()}
      </button>

      {!canCheckIn && !hasCheckedInToday && (
        <p className="mt-2 text-sm text-red-600">
          Giriş yapmak için iş yerinizin 1km yakınında olmalısınız
        </p>
      )}

      {hasCheckedInToday && (
        <p className="mt-2 text-sm text-green-600">
          Harika! Bugün zaten giriş yaptınız. Yarın tekrar gelin!
        </p>
      )}
    </div>
  );
};

export default CheckInButton; 